import mapQrModal from './mapQrModal';

export default function mapButtonProps(component, name = 'buttonProps') {
  const buttonProps = component[name];

  if (!buttonProps) return component;

  return {
    ...component,
    [name]: mapQrModal(buttonProps),
  };
}
